// FAMILY-EXT: контейнер модала внешних хранилищ.

import { connect } from 'react-redux';
import { createSelector } from 'redux-orm';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import orm from '../orm';
import ExternalStoragesModal from '../components/ExternalStoragesModal';

// Список всех доступных проектов + их досок (для scope-picker'а).
const selectProjectsWithBoards = createSelector(
  orm,
  ({ Project }) =>
    Project.all()
      .toModelArray()
      .map((p) => ({
        id: p.id,
        name: p.name,
        boards: p.boards
          .all()
          .toRefArray()
          .map((b) => ({ id: b.id, name: b.name })),
      })),
);

const mapStateToProps = (state) => {
  const currentUser = selectors.selectCurrentUser(state);
  return {
    projects: selectProjectsWithBoards(state),
    isAdmin: !!(currentUser && currentUser.isAdmin),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(entryActions.closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExternalStoragesModal);
